import { createSelector } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";
import { useRequest } from "redux-query-react";
import { MissingChoicesEnum } from "./types";
import { getPortfolioComparisonAssociationById } from "api/admin/src";
import { DashboardTypes } from "components/workspaces/hooks/types";
import { useCurrentDashboardEntityId, useCurrentDashboardType } from "components/workspaces/hooks/use-current-dashboard";
import { widgetSelector } from "store/cross-slice/widgetSelector";
import { WidgetMode } from "store/current-dashboard/types";
const dataSelector = createSelector((state) => state.entities.PortfolioComparisonAssociation, (_, entityId) => entityId, (portfolioComparisonAssociation, entityId) => Object.values(portfolioComparisonAssociation || {}).some((p) => p.comparedPortfolioId === entityId));
const useGetComparisonChoice = (widgetId) => {
    const mode = useSelector((state) => widgetSelector(state, widgetId)?.componentProps?.mode);
    const entityId = useCurrentDashboardEntityId(), entityType = useCurrentDashboardType();
    const required = mode === WidgetMode.Comparison && entityType === DashboardTypes.Portfolio;
    const request = required ? getPortfolioComparisonAssociationById({ id: entityId }) : null;
    const [state] = useRequest(request);
    const data = useSelector((s) => dataSelector(s, entityId));
    return { absent: !data, required, state };
};
export const useGetWidgetMissingChoice = (widgetId) => {
    const compare = useGetComparisonChoice(widgetId);
    if (compare.required && compare.absent) {
        return { state: compare.state, value: MissingChoicesEnum.Compare };
    }
    return null;
};
